import angular from 'angular';

import csmUIAlert from '../alert/alert';
import csmUtilFlash from '../../util/Flash/Flash';

import './commonMenu.css';

export default angular
  .module('csm.ui.commonMenu', [csmUIAlert, csmUtilFlash])
  .directive('commonMenu', commonMenuDirective)
  .directive('cmItem', cmItemDirective)
  .name;

commonMenuDirective.$inject = ['Alert', 'Flash'];
cmItemDirective.$inject = [];
    
/*****************************************************************************************
 * commonMenu */
/**
 * @ngdoc    directive
 * @restrict E
 * @module   csm.ui
 * @name     csm.ui.commonMenu.directive:commonMenu
 *
 * @scope
 * @param {Array}   items          Common database menu items.
 * @param {Object}  select-action  Evaluated when item selected. $item = selected item.
 * @param {Boolean} disabled       Menu disabled flag.
 *
 * @description
 * Product application menu from common database. Top-level is a menu bar with submenus
 * that can also have submenus. When an item is clicked in the menubar, the submenu opens.
 * Mousing over the menu bar items changes the open menu.
 *******************************************************************************/
/* @ngInject */
function commonMenuDirective(Alert, Flash) {
  /*--------------------------------------------------*/
  /* Convert flat list of menu items to pyramid list  */
  /* with 'submenu' properties. This method is called */
  /* recursively and parentID is 0 on first call.     */
  /*--------------------------------------------------*/
  var buildMenu = function (items, parentID) {
    var menuItems = [];

    if (items)
      for (var i = 0; i < items.length; i++)
        if (items[i].parentID == (parentID || 0)) {
          items[i].submenu = buildMenu(items, items[i].menuID);
          menuItems.push(items[i]);
        }
    return menuItems.length ? menuItems : null;
  };

  /*-----------------------------------------*/
  /* Directive controller as 'cm' in $scope. */
  /*-----------------------------------------*/
  var controller = function ($scope, $timeout) {
    $scope.cm = this;
    $scope.$watch('items', function (items) {
      $scope.cm.items = buildMenu(items);
    });

    var openMenuOnMouseover = false; /* Open item submenu on mouseover flag. */
    var openMenuItems = []; /* List of items with open submenus. */
    this.hasFlash =
      Flash.isEnabled(); /* Flash player installed and enabled. */

    /*-----------------------------------*/
    /* Item types are used in templates. */
    /*-----------------------------------*/
    this.itemTypes = {
      POPUP: 'POP',
      FLASH: 'APP',
      PAGE: 'NAV',
      BREAK: 'BREAK',
      MENU: 'MENU'
    };

    /*-------------------------------------------------*/
    /* Mouseout handler for menubar. Closes all menus. */
    /*-------------------------------------------------*/
    this.endMenu = function () {
      openMenuItems = [];
      openMenuOnMouseover = false;
    };

    /*----------------------------------------------------------------*/
    /* Returns true if item is in open menu items list. Used by       */
    /* "ng-class" to add the "cm-open" class to an item menu element. */
    /*----------------------------------------------------------------*/
    this.isOpenMenu = function (item) {
      for (var i = 0; i < openMenuItems.length; i++)
        if (openMenuItems[i].menuID == item.menuID) return true;
      return false;
    };

    /*--------------------------------------------------*/
    /* Click/mouseover handler for menu items. Calls    */
    /* 'selectHandler' for item selected if not a menu. */
    /* Handles menu display changes for menu items.     */
    /*--------------------------------------------------*/
    this.handleItemEvent = function (item, event) {
      var click = event.type == 'click';
      var mouseover = event.type == 'mouseover';
      var isMenuItem = item.type == this.itemTypes.MENU;
      var topmenu = item.parentID == 0;

      /*------------------------------------------------------------------*/
      /* For click of non-menu item, close the menu and call the handler. */
      /*------------------------------------------------------------------*/
      if (click && !isMenuItem) {
        openMenuItems = [];

        if (item.type == this.itemTypes.FLASH && !this.hasFlash)
          Alert.error(
            'This option requires Flash Player.',
            'Flash Player Unavailable'
          );
        else
          $timeout(function () {
            $scope.selectAction({ $item: item });
          }, 0);
        return;
      }

      /*---------------------------------------------------------------*/
      /* Click of a top menu menu item toggles the "open on mouseover" */
      /* flag so menus will open if closed and close if opened.        */
      /*---------------------------------------------------------------*/
      if (click && topmenu) {
        openMenuOnMouseover = !openMenuItems.length && !$scope.menuDisabled;
        mouseover = true;
      }

      /*---------------------------------------------------------------------*/
      /* If the "open on mouseover" flag is set, the open menus list is      */
      /* modified so the parent menu of this item is the last menu open.     */
      /* This will close any menus not in the parent tree of this item. This */
      /* item is then added to the list of open menus if it is a menu item.  */
      /*                                                                     */
      /* If "open on mouseover" is not set, all menus are closed.            */
      /*---------------------------------------------------------------------*/
      if (mouseover)
        if (openMenuOnMouseover) {
          /*-------------------------------------------------------------*/
          /* Remove items from end of open menus list until parent menu  */
          /* is last one. This will close menus that should not be open. */
          /*-------------------------------------------------------------*/
          for (
            var i = openMenuItems.length - 1;
            i >= 0 && openMenuItems[i].menuID != item.parentID;
            i--
          )
            openMenuItems.pop();

          /*-----------------------------------------------------*/
          /* If this is a menu item, add to the open menus list. */
          /*-----------------------------------------------------*/
          if (isMenuItem) openMenuItems.push(item);
        } else openMenuItems = [];
    };
  };

  return {
    restrict: 'E',
    scope: { items: '=', selectAction: '&', menuDisabled: '=disabled' },
    template:
      '<ul class="cm-topmenu" ng-mouseleave="cm.endMenu()"><li ng-repeat="item in cm.items" class="cm-item"/></li></ul>',
    controller: controller
  };
}

/*****************************************************************************************
 * cm-item */
/**
 * Internal template for menu items in common-menu directive.
 *****************************************************************************************/
/* @ngInject */
function cmItemDirective() {
  return {
    restrict: 'C',
    template: [
      /*-------------*/
      /* Break item. */
      /*-------------*/
      '<span ng-if="item.type == cm.itemTypes.BREAK" class="cm-break"></span>',

      /*------------------*/
      /* Selectable item. */
      /*------------------*/
      '<button    ng-if="item.type != cm.itemTypes.BREAK"' +
        'ng-click="cm.handleItemEvent(item, $event)"' +
        'ng-mouseover="cm.handleItemEvent(item, $event)"' +
        'ng-class="{\'cm-open\': cm.isOpenMenu(item)}"' +
        'ng-disabled="!item.enabled || menuDisabled"' +
        'tabindex="{{item.parentID == 0 ? 0 : -1}}">',

      /*-----------------------------------*/
      /* If flash player is not available, */
      /* show pseudo icon for flash apps.  */
      /*-----------------------------------*/
      '<div ng-if="item.type == cm.itemTypes.FLASH && !cm.hasFlash">',
      '<span>Fp</span>',
      '</div>',

      /*-------------------------*/
      /* Show item icon, if any. */
      /*-------------------------*/
      '<img ng-if="item.icon && (item.type != cm.itemTypes.FLASH || cm.hasFlash)" ng-src="{{item.icon}}"/>',

      /*---------------*/
      /* Option title. */
      /*---------------*/
      '<span ng-if="item.type != cm.itemTypes.BREAK">{{item.option}}</span>',
      '</button>',

      /*----------*/
      /* Submenu. */
      /*----------*/
      '<div ng-if="item.type == cm.itemTypes.MENU">',
      '<div class="cm-arrow"></div>',
      '<div ng-if="item.parentID == 0" class="cm-spacer"></div>',
      '<ul class="cm-submenu"><li ng-repeat="item in item.submenu" class="cm-item"/></li></ul>',
      '</div>'
    ].join('\n')
  };
}
